import { Action, createReducer, on } from '@ngrx/store';
import { setPolicyId } from './context.actions';
import { initialState, ContextState } from './context.state';
import { Context } from '@shared/models/context.model';

export const contextReducer = createReducer(
  initialState,
  on(setPolicyId, (state, { policyId }: ReturnType<typeof setPolicyId>) => {
    const next = { ...state, policyId };
    return next;
  })
);

export function reducer(state: Context | undefined, action: Action) {
  return contextReducer(state, action);
}